import { FileItem } from 'ng2-file-upload';

import { FileUploaderModel } from '../../shared/components/file-uploader/file-uploader.model';

export enum PieceJointType {
    REQUETE = 'REQ',
    ACTE_ATTAQUE = 'DEC',
    RECLAMATION_PREALABLE = 'REP',
    INVENTAIRE_REQUETE = 'RIN',
    PIECE_JOINTE_REQUETE = 'PRQ',
    PIECE_JOINTE_DOCUMENT = 'PJD',
    MEMOIRE = 'MEM',
    INVENTAIRE_DOSSIER = 'DIN',
    PIECES = 'PIE',
    PIECE_POSTALE = 'POSTALE'
}

export enum PieceComplementaireOrigineType {
    MAL_INTERPRETE = 'MLINTER',
    MAL_APPRECIE = 'MLAPP',
    RAPO = 'RAPO',
    SOMME_DUE = 'SOMDUE',
    MONTANT_DU = 'MONTDU',
    AVIS_IMPOSITION_INFONDEE_ET_AUTRE = 'AIINFAUT',
    PRECISION_PREJUDICE = 'PRECPREJ',
    REQUETE_REDIGEE_JUSTIFICATIF = 'REREJU',
    DEFAULT = 'DEFAULT'
}

export interface EventPieceJointe {
    id?: number;
    fileName?: string;
    libelle: string;
    ordre?: number;
    fileType: string;
    origin?: string;
    fileApiId?: string;
    mimeType?: string;
    fileHash?: string;
    fileItem?: FileItem;
    complementaryFileOriginType?: PieceComplementaireOrigineType;
}

export class GenericPiece implements EventPieceJointe {
    public libelle: string;
    public fileType: PieceJointType;
    public complementaryFileOriginType?: PieceComplementaireOrigineType;

    constructor(public fileModel: FileUploaderModel) {
    }


    // Serialize
    toDTO(): EventPieceJointe {
        let ret: EventPieceJointe = {
            fileApiId: this.fileModel.fileApiId,
            libelle: this.libelle,
            fileType: this.fileType,
            complementaryFileOriginType: this.complementaryFileOriginType
        };
        return ret;
    }
}

export class Memoire extends GenericPiece {
    constructor(fileModel: FileUploaderModel) {
        super(fileModel);

        this.libelle = 'Memoire';
        this.fileType = PieceJointType.MEMOIRE;
    }
}

export class PieceRequete extends GenericPiece {
    constructor(fileModel: FileUploaderModel) {
        super(fileModel);

        this.libelle = 'Requête';
        this.fileType = PieceJointType.REQUETE;
    }
}

export class PieceActeAttaque extends GenericPiece {
    constructor(fileModel: FileUploaderModel) {
        super(fileModel);

        this.libelle = 'Acte attaqué';
        this.fileType = PieceJointType.ACTE_ATTAQUE;
    }
}

export class PieceReclamationPrealable extends GenericPiece {
    constructor(fileModel: FileUploaderModel) {
        super(fileModel);

        this.libelle = 'Réclamation préalable';
        this.fileType = PieceJointType.RECLAMATION_PREALABLE;
    }
}


export class PieceComplementaire extends GenericPiece {

    constructor(fileModel: FileUploaderModel, type: PieceJointType, complementaryFileOriginType: PieceComplementaireOrigineType) {
        super(fileModel);

        this.fileType = type;
        this.complementaryFileOriginType = complementaryFileOriginType;
    }
}

export class PiecePostale implements EventPieceJointe {
    public fileType = PieceJointType.PIECE_POSTALE;

    constructor(public libelle: string) {
    }

    // Serialize
    toDTO(): EventPieceJointe {
        return {
            libelle: this.libelle,
            fileType: this.fileType
        };
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe.model.ts